import { render, staticRenderFns } from "./wholeChainlist.vue?vue&type=template&id=544c50db&"
import script from "./wholeChainlist.vue?vue&type=script&lang=js&"
export * from "./wholeChainlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports